import { fullscreenSplitViewState, openSplitViewState } from '@approvalmax/ui/src/components';
import { useSetAtom } from 'jotai';
import { useUnmount } from 'react-use';

import { splitViewGoToBarDefaultSettings, splitViewGoToBarSettingsState } from '../components';
import { ContentSplitViewMode, contentSplitViewState } from '../states';

export const useCloseSplitViewOnUnmount = () => {
    const setOpenSplitView = useSetAtom(openSplitViewState);
    const setContentSplitView = useSetAtom(contentSplitViewState);
    const setFullscreenState = useSetAtom(fullscreenSplitViewState);
    const setGoToBarSettings = useSetAtom(splitViewGoToBarSettingsState);

    useUnmount(() => {
        setOpenSplitView(false);
        setFullscreenState(false);
        setContentSplitView({ mode: ContentSplitViewMode.Empty });
        setGoToBarSettings(splitViewGoToBarDefaultSettings);
    });
};
